module.exports = "<div class=\"bgimg\">\n  <div class=\"topleft\">\n    <!-- <p>Logo</p> -->\n  </div>\n  <div class=\"middle\">\n    <h1>COMING SOON</h1>\n    <hr>    \n  </div>\n  <div class=\"bottomleft\">\n    <p>SASA-Doctor</p>\n  </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/under-construction/under-construction.component.html
// module id = ./src/app/under-construction/under-construction.component.html
// module chunks = main